import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

import './assets/css/cui.css'
import './assets/css/less.css'
import './assets/css/style.css'
import './assets/css/app.css'

Vue.use(VueRouter);

const index = () => import('./pages/Home.vue');
const product = () => import('./pages/Product.vue');
const about = () => import('./pages/About.vue');
const contact = () => import('./pages/Contact.vue');

const routes = [
    {path: '/', component: index},
    {path: '/product', component: product},
    {path: '/about', component: about},
    {path: '/contact', component: contact}
];

const router = new VueRouter({
    // mode: 'history', // 需要nginx在location中配置try_files $uri $uri/ /index.html;
    routes, // (缩写) 相当于 routes: routes
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    }
});

Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App),
}).$mount('#app');
